'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.util = exports.instanceNames = exports.typeNames = exports.trackers = undefined;

var _createTrackers = require('./trackers/create-trackers');

var _createTrackers2 = _interopRequireDefault(_createTrackers);

var _instanceNames = require('./trackers/instance-names');

var _instanceNames2 = _interopRequireDefault(_instanceNames);

var _article = require('./trackers/pulse/view/article');

var _article2 = _interopRequireDefault(_article);

var _page = require('./trackers/pulse/view/page');

var _page2 = _interopRequireDefault(_page);

var _ui = require('./trackers/pulse/engagement/ui');

var _ui2 = _interopRequireDefault(_ui);

var _typeNames = require('./trackers/type-names');

var _typeNames2 = _interopRequireDefault(_typeNames);

var _util = require('./util');

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackers = { pulseViewArticleTracker: _article2.default, pulseEngagementUiTracker: _ui2.default, pulseViewPageTracker: _page2.default };

exports.default = _createTrackers2.default;
exports.trackers = trackers;
exports.typeNames = _typeNames2.default;
exports.instanceNames = _instanceNames2.default;
exports.util = util;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/index.js
 ** module id = 57
 ** module chunks = 1
 **/